import { CHECK_INTERVAL, STARTUP_TIMEOUT } from './releaseController';

export function browserReleaseDependencies() {
  return {
    loadedBuild: process.env.REACT_APP_RELEASE_ID,
    attempts: {
      getItem: (key) => window.sessionStorage.getItem(key),
      setItem: (key, value) => window.sessionStorage.setItem(key, value),
    },
    reload: () => window.location.reload(),
    readRelease: async () => {
      const controller = new AbortController();
      let timer;
      try {
        return await Promise.race([
          (async () => {
            const response = await fetch('/release.json', {
              cache: 'no-store',
              credentials: 'omit',
              signal: controller.signal,
            });
            if (!response.ok || !/application\/json/i.test(response.headers.get('content-type') || '')) {
              throw new Error('Release metadata unavailable');
            }
            return response.json();
          })(),
          new Promise((_, reject) => {
            timer = setTimeout(() => {
              controller.abort();
              reject(new Error('Release check timed out'));
            }, STARTUP_TIMEOUT);
          }),
        ]);
      } finally {
        clearTimeout(timer);
      }
    },
  };
}

export function monitorBrowserRelease(controller) {
  const onVisible = () => {
    if (document.visibilityState === 'visible') controller.event();
  };
  const onOnline = () => controller.event();
  document.addEventListener('visibilitychange', onVisible);
  window.addEventListener('online', onOnline);
  const interval = setInterval(() => {
    if (document.visibilityState === 'visible') controller.check();
  }, CHECK_INTERVAL);
  return () => {
    clearInterval(interval);
    document.removeEventListener('visibilitychange', onVisible);
    window.removeEventListener('online', onOnline);
  };
}
